<!-- - ARMING-->
<div
  class="event-log-box"
  [id]="'log-box-' + log.id"
  [class.is-select]="log.isSelected"
  [class.is-warning]="parseWarningLog()"
  (mouseenter)="onHoverLog($event, log.id)"
  (mouseleave)="onMouseLeaveLog($event, log)"
>
  <div class="event-log-action-box">
    <!-- arming status-->
    <ng-container>
      <div class="action-box" *ngIf="checkArmingStatus()" [ngClass]="computedActionName(log.action) + '-background'">
        <comp-icon
          [icon]="computedActionName(log.action)"
          [color]="armingIconColor(log.action)"
          [size]="32"
        ></comp-icon>
      </div>
    </ng-container>
    <!-- others-->
    <ng-container *ngIf="!checkArmingStatus()">
      <div class="action-box v-center default">
        <i class="material-icons" *ngIf="logIcon.type === 'material'" style="color: #8b8b8b; font-size: 32px">{{
          logIcon.name
        }}</i>
        <comp-icon *ngIf="logIcon.type === 'comp'" [icon]="logIcon.name" [color]="'#8B8B8B'"></comp-icon>
      </div>
    </ng-container>
  </div>
  <div class="event-log-metadata">
    <div class="flex" style="gap: 6px; flex-direction: column">
      <div class="v-center" style="gap: 8px; flex-wrap: wrap">
        <div class="event-log-metadata-time">{{ log.eventCreated }}</div>
        <div class="event-log-metadata-category">
          <div class="badge" *ngIf="checkArmingStatus()" [ngClass]="computedActionName(log.action) + '-background'">
            {{ capitalizeFirstLetter(log.action) }}
          </div>
          <div class="badge default" *ngIf="!checkArmingStatus()">{{ capitalizeFirstLetter(log.action) }}</div>
          <div class="badge automation" *ngIf="isAutomationRule(log)" style="margin-left: 4px">Automation Action</div>
        </div>
        <div
          class="--g-tooltip-content"
          *ngIf="parseWarningLog()"
          (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
        >
          <comp-icon class="--g-tooltip-icon" [icon]="'info'" [size]="16" [color]="'rgb(205, 61, 100)'"></comp-icon>
          <div class="--g-tooltip" style="text-transform: none">
            This event includes data that could not be transmitted to the monitoring station.
          </div>
        </div>
      </div>
      <div class="v-center" style="gap: 8px; flex-wrap: wrap">
        <ng-container *ngFor="let list of log.eventCodeList">
          <div
            class="--g-tooltip-content"
            (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
            style="margin: 0"
          >
            <div class="badge xml-code">{{ list.code }}</div>
            <div class="--g-tooltip tooltip-background">XML Code</div>
          </div>
        </ng-container>
      </div>
      <div class="event-log-metadata-device" style="flex-wrap: wrap">
        <div
          class="--g-tooltip-content"
          *ngIf="log.zone_number"
          (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
          style="margin: 0"
        >
          <div class="event-log-metadata-device-zone">{{ log.zone_number }}</div>
          <div class="--g-tooltip tooltip-background">Device ID</div>
        </div>
        <div class="event-log-metadata-device-name v-center" [class.no-name]="!log.name">
          <div *ngIf="log?.partitionNumber || log?.partitionName">
            Partition {{ log?.partitionNumber }} ({{ log?.partitionName }})
          </div>
          <div *ngIf="!log?.partitionNumber" style="margin-left: 4px">
            {{ log.name ?? "No Name" }}
          </div>
        </div>
      </div>
      <div class="event-log-metadata-other">
        <ng-container *ngIf="!log.email">{{ log.trigger }} - {{ log.status_text }}</ng-container>
        <ng-container *ngIf="log.email">{{ log.email }} - {{ log.status_text }}</ng-container>
        <div *ngIf="log?.partnerDescription">{{ log?.partnerDescription }}</div>
      </div>
    </div>
    <div class="event-log-metadata-id">
      <span *ngIf="log?.event_id">ID {{ log.event_id }}</span>
      <span *ngIf="log?.partnerEventId"> | Partner ID {{ log.partnerEventId }}</span>
    </div>
    <!-- SLOT : toolbar-->
    <ng-container *ngTemplateOutlet="toolbar; context: { log: log }"></ng-container>
  </div>
</div>
